import React from 'react';
import styled from 'styled-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import Typography from '@latitude/typography';
import Section from '@latitude/section-rebrand';
import ProofPoint from '../../ProofPoint/ProofPointV2';
import { REBRAND_COLOR } from '@/utils/constants';

const Wrapper = styled.div`
  padding-top: 32px;
  padding-bottom: 32px;

  background-color: ${({ themeType }) => {
    switch (themeType?.toLowerCase()) {
      case 'white':
        return REBRAND_COLOR.WHITE;
      case 'stone':
        return REBRAND_COLOR.STONE;
      default:
        return REBRAND_COLOR.WHITE;
    }
  }};

  .section__content {
    padding: 0;

    @media (max-width: 767px) {
      padding: 0 15px;
      max-width: 540px;
    }

    @media (min-width: 768px) {
      max-width: 690px;
    }

    @media (min-width: 992px) {
      max-width: 930px;
    }

    @media (min-width: 1200px) {
      max-width: 1110px;
    }
  }
`;

const Heading = styled.div`
  margin: 0;
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 32px 0;
  gap: 30px;

  @media (max-width: 767px) {
    gap: 16px;
  }
`;

const ProofPointCollection = props => {
  const {
    title,
    subTitle,
    description,
    proofPoints,
    proofPointTitleSize = 'Heading 6',
    proofPointIconSize = 40,
    theme = 'Grey'
  } = props.data;

  const TITLE_OPTIONS = {
    renderNode: {
      [BLOCKS.HEADING_3]: (_node, children) => (
        <Typography.SH1 semibold color={REBRAND_COLOR.BLACK}>
          {children}
        </Typography.SH1>
      )
    }
  };

  const SUB_TITLE_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.Body semibold color={REBRAND_COLOR.BLACK_80}>
          {children}
        </Typography.Body>
      )
    }
  };



  const DESCRIPTION_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.CTASmall color={REBRAND_COLOR.BLACK_70}>
          {children}
        </Typography.CTASmall>
      )
    }
  };

  return (
    <Wrapper
      id={props.id || ''}
      themeType={theme}
      className="proof-point-collection"
    >
      <Section>
        {title && (
          <Heading>{documentToReactComponents(title, TITLE_OPTIONS)}</Heading>
        )}
        {subTitle && (
          documentToReactComponents(subTitle, SUB_TITLE_OPTIONS)
        )}

        <Content pointsLength={proofPoints?.length}>
          {proofPoints?.map((point, index) => (
            <ProofPoint
              key={index}
              proofPointTitleSize={proofPointTitleSize}
              proofPointIconSize={proofPointIconSize}
              point={point}
              theme={theme}
              numOfPoints={proofPoints?.length}
              category={props?.category || 'text-link'}
              action={props?.action || 'internal-link'}
            />
          ))}
        </Content>

         {description && (
          documentToReactComponents(description, DESCRIPTION_OPTIONS)
        )}

      </Section>
    </Wrapper>
  );
};

export default ProofPointCollection;